// extracted by mini-css-extract-plugin
export var collapsedSummary = "_k5-0";